// ============================================================================
// LAYOUT CONSTANTS
// ============================================================================
export const LAYOUT_MAIN = 'LAYOUT_MAIN';
export const LAYOUT_MINIMAL = 'LAYOUT_MINIMAL';
export const LAYOUT_BODEGA = 'LAYOUT_BODEGA';
export const LAYOUT_VITICULTOR = 'LAYOUT_VITICULTOR';

// ============================================================================
// OTHER CONSTANTS
// ============================================================================
export const LINK_SIGPAC = 'https://sigpac.mapama.gob.es/fega/visor/';

// ============================================================================
// ENUM CONSTANTS - Re-exportadas desde enums para compatibilidad
// ============================================================================

export {
    STATE_BORRRADOR,
    STATE_ACTIVO,
    STATE_BAJA,
    STATE_TRASPASADO,
    STATE_SOLICITUD
} from './enums/statesEntity';

export {
    SCOPE_MIEMBRO,
    SCOPE_USO,
    SCOPE_PRODUCCION,
    SCOPE_ELABORACION,
    SCOPE_ALMACENAMIENTO,
    SCOPE_CRIANZA,
    SCOPE_EMBOTELLADO
} from './enums/scopes';

export {
    CONTACT_TYPE_REPRESENTANTE,
    CONTACT_TYPE_AUTORIZADO,
    CONTACT_TYPE_CONTACTO,
    CONTACT_TYPE_DIRECCION
} from './enums/contactType';

export {
    LOCK_PARCEL_COSECHA_EN_VERDE,
    LOCK_PARCEL_EXCESO_RENDIMIENTO
} from './enums/locksParcel';

export {
    INCIDENCE_PARCEL_COSECHA_EN_VERDE,
    INCIDENCE_PARCEL_EXCESO_RENDIMIENTO_CAMPO,
    INCIDENCE_PARCEL_EXCESO_RENDIMIENTO_DECLARADO,
    INCIDENCE_PARCEL_NO_GRADO_MINIMO
} from './enums/incidenceParcel';

export {
    STATE_EXECUTION_PENDIENTE,
    STATE_EXECUTION_EN_CURSO,
    STATE_EXECUTION_FINALIZADO
} from './enums/statesExecution';

export {
    STATE_LIQUIDATION_POR_LIQUIDAR,
    STATE_LIQUIDATION_NO_LIQUIDABLE,
    STATE_LIQUIDATION_LIQUIDADO
} from './enums/statesLiquidation';

export {
    STATE_RESOLUTION_POR_RESOLVER,
    STATE_RESOLUTION_EN_CURSO,
    STATE_RESOLUTION_RESUELTO,
    STATE_RESOLUTION_RECHAZADO
} from './enums/statesResolution';

export {
    RESULT_RESOLUTION_FAVORABLE,
    RESULT_RESOLUTION_NO_FAVORABLE,
    RESULT_RESOLUTION_PENDIENTE
} from './enums/resultsResolution';

export {
    USE_FORM_SOLICITUD,
    USE_FORM_ACTA,
    USE_FORM_RESOLUTION
} from './enums/usesForm';

export {
    STATE_TASK_PENDIENTE,
    STATE_TASK_POR_HACER,
    STATE_TASK_EN_CURSO,
    STATE_TASK_FINALIZADA
} from './enums/statesTask';

export {
    VALIDATION_TASK_POR_VALIDAR,
    VALIDATION_TASK_VALIDADA,
    VALIDATION_TASK_RECHAZADA
} from './enums/validationsTask';

export {
    REPRESENTATION_ROL_INSPECTOR,
    REPRESENTATION_ROL_FORMADOR,
    REPRESENTATION_ROL_OBSERVADOR,
    REPRESENTATION_ROL_AUDITOR
} from './enums/representationRol';

export {
    AUTH_DOCUMENT_AUTORIZACION,
    AUTH_DOCUMENT_DNI,
    AUTH_DOCUMENT_PODERES,
    AUTH_DOCUMENT_ESCRITURA
} from './enums/authDocument';

export {
    AUTH_ACTION_TODO,
    AUTH_ACTION_DECLARACIONES,
    AUTH_ACTION_SOLICITUDES,
    AUTH_ACTION_CONSULTAS,
    AUTH_ACTION_AUTORIZACIONES
} from './enums/authAction';

export { LOG_DATA, LOG_STATE } from './enums/changeLogs';

export {
    TYPE_QUOTA_COMPLETA,
    TYPE_QUOTA_PARCIAL,
    TYPE_QUOTA_YA_EMITIDA
} from './enums/typeQuota';

export {
    TYPE_REPRESENTATIVE_BODEGA,
    TYPE_REPRESENTATIVE_VITICULTOR
} from './enums/typeRepresentative';

export {
    STATE_ARQUETA_ALTA_CON_CONTADOR,
    STATE_ARQUETA_ALTA_SIN_CONTADOR,
    STATE_ARQUETA_BAJA_CON_ARQUETA,
    STATE_ARQUETA_BAJA_SIN_ARQUETA
} from './enums/statesArqueta';

export {
    STATE_ACTIVO_DISPONIBLE,
    STATE_ACTIVO_EN_USO,
    STATE_ACTIVO_BAJA
} from './enums/statesAsset';

export { USE_PARCEL_CONSUMO, USE_PARCEL_DERRAMA } from './enums/useParcel';
